const jbColors = {
  core: {
    reflexBlue: {
      100: '#001489',
      70: '#4D5BAE',
      60: '#6672b8',
      50: '#808AC4',
      40: '#99A1D0',
      20: '#ccd0e7',
      10: '#e6e8f3',
    },
    stone: {
      80: '#C0BB98',
      20: '#EFEEE5',
      10: '#F7F6F2',
    },
    violetGrey: {
      20: '#e5e0e1',
    },
  },
  support: {
    alert: {
      100: '#EE251A',
    },
    greenSmoke: {
      100: '#717C7D',
      80: '#8D9697',
      60: '#AAB0B1',
      40: '#c6cbcb',
      30: '#D4D8D8',
      20: '#E3E5E5',
      10: '#F1F1F2',
    },
  },
  technical: {
    amberYellow: {
      100: '#CC8A00',
      80: '#D6A133',
      40: '#EBD099',
    },
    carminRed: {
      100: '#971B2F',
      80: '#AC4959',
      50: '#cb8d97',
      30: '#e0bbc1',
      20: '#ead1d5',
    },
    forestGreen: {
      100: '#008675',
      80: '#339E91',
      40: '#99CFC7',
    },
    mulberryPurple: {
      100: '#6E2B62',
    },
    persianBlue: {
      100: '#007FA3',
      80: '#3399b5',
    },
  },
  app: {
    lightGrey: '#CCCCCC',
    white: '#FFFFFF',
  },
  black: {
    80: '#333333',
    60: '#666666',
    40: '#999999',
  },
};

export { jbColors };
